import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loading: false,
    show: true,
    pageStatusList: [],
    publishStatusList: [],
    appealStatusList: [],
    PageLanguageList: [],
    PageOwnerList: [],
    authorityList: [],

  },
  mutations: {
    SET_LOADING (state, res) {
      state.loading = res
    },
    SET_SHOW (state, res) {
      state.show = res
    },
    REFRESH (state, vue) {
      state.show = false
      vue.$nextTick(() => (state.show = true))
    },
    SET_PAGE_STATUS_LIST (state, res) {
      state.pageStatusList = res
    },
    SET_PUBLISH_STATUS_LIST (state, res) {
      state.publishStatusList = res
    },
    SET_APPEAL_STATUS_LIST (state, res) {
      state.appealStatusList = res
    },
    SET_PAGE_LANGUAGE_LIST (state, res) {
      state.PageLanguageList = res
    },
    SET_PAGE_OWNER_LIST (state, res) {
      state.PageOwnerList = res
    },
    SET_AUTHORITY (state, res) {
      state.authorityList = res
    },
    CLEAR_LIST (state) {
      state.pageStatusList = [];
      state.publishStatusList = [];
      state.appealStatusList = [];
      state.PageLanguageList = [];
      state.PageOwnerList = [];
      state.authorityList = [];
    }
  },
  actions: {
  },
  modules: {
  },
});
